<app-maintenance-overlay></app-maintenance-overlay>
<app-offline-banner></app-offline-banner>
<app-header *ngIf="!hideHeader"></app-header>
<div class="app-container">
  <div [ngClass]="{'main-view': !hideHeader}">
    <div class="content">
      <router-outlet (activate)="onActivate($event, outlet)" #outlet></router-outlet>
      <app-my-loader></app-my-loader>
    </div>
    <app-footer *ngIf="!hidefooter"></app-footer>
  </div>
</div>